import {get} from './index'
export const Increament = (dispatch) => {
    return dispatch({type: "INC"})
}

export const Decreament = (dispatch) => {
    return dispatch({type: "DEC"})
}

export const fetchMockData = (dispatch) => {
    const url = "https://638c0f59d2fc4a058a513c96.mockapi.io/api/v1/getusers"
    get({url}).then((response) => {
        console.log("test ji", response)
    })
}